
import cookieUtil from '@/library/cookieUtil'
// 获取授权信息
export function getAuth () {
  var mogo_default = cookieUtil.getCookie('mogo_default', true);
  return mogo_default || {}
}
export const mixins = {}
export default mixins


// WEBPACK FOOTER //
// ./src/mixins/authorize.js